<template>
  <div class="container">
    <div class="desc-box">
      <div class="text-box">
        <div class="text-item" v-for="(item, index) in data.desc1" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="text-box">
        <div class="text-item" v-for="(item, index) in data.desc2" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="stress-box">
        <div class="stress-title">{{ data.stress.title }}</div>
        <div
          class="stress-item"
          v-for="(item, index) in data.stress.items"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="text-box">
        <div class="text-item" v-for="(item, index) in data.desc3" :key="index">
          {{ item }}
        </div>
      </div>
    </div>

    <div class="content-box">
      <div
        class="content-item-box"
        v-for="(content, cIndex) in data.contents"
        :key="cIndex"
      >
        <div class="content-title" v-if="content.title">
          {{ content.title }}
        </div>
        <div class="content-stress" v-if="content.stress">
          {{ content.stress }}
        </div>
        <div
          class="content-item-box"
          v-if="content.items && content.items.length"
        >
          <div
            class="content-item"
            v-for="(item, iIndex) in content.items"
            :key="iIndex"
          >
            <div class="item-title" v-if="item.itemTitle">
              {{ item.itemTitle }}
            </div>
            <div
              class="item-list-box"
              v-if="item.itemList && item.itemList.length"
            >
              <div
                class="item-list"
                v-for="(list, lIndex) in item.itemList"
                :key="lIndex"
              >
                <div class="list-title" v-if="list.listTitle">
                  {{ list.listTitle }}
                </div>
                <div class="list-image" v-if="list.listTable">
                  <table>
                    <tr>
                      <th width="20%"></th>
                      <th width="30%">第三方收集的信息类型</th>
                      <th width="30%">场景用途描述</th>
                      <th width="30%">第三方类型</th>
                    </tr>
                    <!-- <tr>
                      <td rowspan="3">野兽派官网</td>
                      <td>用户信息，浏览行为</td>
                      <td>个性化推荐</td>
                      <td>阿里云智能推荐</td>
                    </tr> -->
                    <tr>
                      <td rowspan="2">野兽派官网</td>
                      <td>网络状态、操作系统信息、用户所在城市、浏览器信息</td>
                      <td>数据分析、数据统计</td>
                      <td>TalkingData</td>
                    </tr>
                    <tr>
                      <td>
                        网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）
                      </td>
                      <td>数据分析、数据统计</td>
                      <td>神策数据SDK</td>
                    </tr>
                    <!-- <tr>
                      <td rowspan="5">野兽派APP</td>
                      <td>用户信息，浏览行为</td>
                      <td>个性化推荐</td>
                      <td>阿里云智能推荐</td>
                    </tr> -->
                    <tr>
                      <td rowspan="14">野兽派APP</td>
                      <td>
                        设备Mac地址、唯一设备识别码(IMEl/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息)
                      </td>
                      <td>
                        消息推送，及提供统计分析服务,并通过地理位置校准报表数据准确性,提供基础反作弊能力
                      </td>
                      <td>友盟+SDK</td>
                    </tr>
                    <tr>
                      <td>
                        设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发；
                        设备标识符（IMEI、IDFA、Android ID、GAID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、硬件序列号信息、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；
                        网络信息(IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；
                        应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。
                        数据处理方式：通过去标识化、加密传输及其他安全方式
                        关于自启动：为保障您可以正常接收推送消息，本应用使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，避免遗漏重要消息通知遗漏。
                      </td>
                      <td>
                        为 APP 用户提供信息推送服务
                      </td>
                      <td>极光推送SDK</td>
                    </tr>
                    <tr>
                      <td>
                        应用信息、设备信息（设备的硬件信息、系统基本信息和系统设置）
                      </td>
                      <td>
                        推送消息
                      </td>
                      <td>华为 HMS SDK</td>
                    </tr>
                    <tr>
                      <td>
                        应用匿名标识 (AAID)，应用 Token
                      </td>
                      <td>
                        推送消息
                      </td>
                      <td>荣耀推送 SDK</td>
                    </tr>
                    <tr>
                      <td>
                        应用基本信息（MCS 应用包名、应用版本号、OPUSH SDK版本号），应用内设备标识符（RegistraterID、appKey、appSecret）
                      </td>
                      <td>
                        推送消息
                      </td>
                      <td>OPPO 推送 SDK</td>
                    </tr>
                    <tr>
                      <td>
                        应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息
                      </td>
                      <td>
                        推送消息
                      </td>
                      <td>vivo 推送 SDK</td>
                    </tr>
                    <tr>
                      <td>
                        设备相关信息（手机品牌、手机型号、系统版本、系统语言，以及设备标识符PUSHID）和应用信息、推送状态
                      </td>
                      <td>
                        推送消息
                      </td>
                      <td>魅族推送 SDK</td>
                    </tr>
                    <tr>
                      <td>设备唯一标识码、网络状态、网络制式、设备序列号</td>
                      <td>消息推送</td>
                      <td>小米推送SDK</td>
                    </tr>
                    <tr>
                      <td>
                        位置信息(可能包括GNSS信息、WIFI地址及信号强度信息、基站ID数据信息、传感器信息、手机信号强度信息)、WiFi状态、设备信息(包括AndroidID、操作系统版本、设备品牌及型号、设备配置、应用信息(应用名))，详细隐私政策链接：https://lbsyun.baidu.com/index.php?title=openprivacy
                      </td>
                      <td>
                        优化定位，追踪、排查、诊断、统计服务中的各类问题，保障产品和服务正常运行
                      </td>
                      <td>百度定位SDK 开发者名称：北京百度网讯科技有限公司</td>
                    </tr>
                    <tr>
                      <td>网络状态、操作系统信息、用户所在城市、设备识别码</td>
                      <td>数据分析、数据统计</td>
                      <td>TalkingData</td>
                    </tr>
                    <tr>
                      <td>
                        网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）
                      </td>
                      <td>数据分析、数据统计</td>
                      <td>神策数据SDK</td>
                    </tr>
                    <tr>
                      <td>
                        设备及系统信息（包括操作系统类型、系统版本、App包名、App版本、设备类型、设备厂商、设备型号）、网络身份标识信息（IP地址）
                      </td>
                      <td>售后客服</td>
                      <td>智齿客服SDK</td>
                    </tr>
                    
                    <tr>
                      <td>
                        设备标识符（Android如IMEI、Android ID、IMSI，iOS如IDFV）、MAC地址、IP地址、位置信息
                      </td>
                      <td>为用户提供QQ三方登录功能，帮助用户分享内容至QQ</td>
                      <td>QQ互联（腾讯开放平台）SDK</td>
                    </tr>
                    <tr>
                      <td>
                        设备标识符（Android如IMEI、Android ID、IMSI，iOS如IDFV）、MAC地址、IP地址、位置信息
                      </td>
                      <td>为用户提供微信三方登录功能，帮助用户分享内容至微信，帮助用户在应用内使用微信支付</td>
                      <td>微信Open（微信开放平台）SDK</td>
                    </tr>
                    <!-- <tr>
                      <td rowspan="4">野兽派小程序</td>
                      <td>用户信息，浏览行为</td>
                      <td>个性化推荐</td>
                      <td>阿里云智能推荐</td>
                    </tr> -->
                    <tr>
                      <td rowspan="3">野兽派小程序</td>
                      <td>定位信息、网络状态</td>
                      <td>地址导航、门店定位</td>
                      <td>腾讯地图</td>
                    </tr>
                    <tr>
                      <td>网络状态、操作系统信息、用户所在城市、设备识别码</td>
                      <td>数据分析、数据统计</td>
                      <td>TalkingData</td>
                    </tr>
                    <tr>
                      <td>
                        网络状态、GPS定位信息、设备信息（IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI、MAC地址）
                      </td>
                      <td>数据分析、数据统计</td>
                      <td>神策数据SDK</td>
                    </tr>
                  </table>
                </div>
                <div
                  class="list-item-box"
                  v-if="list.listItems && list.listItems.length"
                >
                  <div
                    class="list-item"
                    v-for="(listItem, liIndex) in list.listItems"
                    :key="liIndex"
                  >
                    {{ listItem }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bridge from "@beastshop/bridge";
import ruleData from "./data.js";

export default {
  name: "rule",

  data() {
    return {
      dataLoaded: false,
      data: ruleData,
    };
  },

  components: {},

  created() {
    this.$hideLoading();
    this.$setTitle("THE BEAST 野兽派个人信息保护政策");
  },

  methods: {},
};
</script>

<style lang="stylus" src="./index.styl"></style>



// WEBPACK FOOTER //
// index.vue?75d92302